import reducer from './reducer';

export { setNotify } from './reducer';

export default reducer;